import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const alienvaultUsm = defineConnector({
  identifier: "alienvaultUsm",
  name: "AlienVault USM",
  tagLine: "Unified security management and SIEM",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ apiAddress }) =>
    apiAddress
      ? `${apiAddress.replace(/\./g, "\\.").replace(/\/$/, "")}/.*`
      : "https://.*\\.alienvault\\.cloud/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create an API client",
      items: [
        {
          kind: "markdown",
          content:
            "In USM Anywhere, click your profile icon, go to **Profile Settings → API Clients**, and create a new client to obtain a client ID and client secret.",
        },
      ],
    },
    {
      title: "Enter your API details",
      items: [
        {
          kind: "url",
          label: "API address",
          placeholder: "https://<subdomain>.alienvault.cloud",
          required: true,
          target: { kind: "configuration", field: "apiAddress" },
          helperText: "Your USM Anywhere subdomain URL.",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
        {
          kind: "input",
          label: "Version",
          required: true,
          defaultValue: "2.0",
          target: { kind: "configuration", field: "version" },
          helperText: "USM API version (e.g., 2.0).",
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ apiAddress, version }) =>
      `${(apiAddress ?? "").replace(/\/$/, "")}/api/${version || "2.0"}/oauth/token`,
    tokenEndpointAuthMethod: () => "client_secret_basic",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: ({ apiAddress, version }) =>
      `${(apiAddress ?? "").replace(/\/$/, "")}/api/${version || "2.0"}/users/me`,
  },
});
